import { COMING_SOON as COMING_SOON_FALLBACK } from '../config/site';
import { functionsBase } from '../config/functionsBase';

const FUNCTIONS_BASE = functionsBase('/.netlify/functions');

export const DEFAULT_SITE_CONFIG = {
  comingSoon: Boolean(COMING_SOON_FALLBACK),
  sections: {
    homeWorld: true,
    homeJoin: true,
    homeCta: true,
    serverStatus: true,
  },
  pages: {
    vip: true,
    conta: true,
    nexus: true,
    team: true,
    economia: true,
    download: true,
  },
};

let cache = null;
let inflight = null;

export function clearSiteConfigCache() {
  cache = null;
  inflight = null;
}

export function setSiteConfigCache(config) {
  cache = {
    ...DEFAULT_SITE_CONFIG,
    ...config,
    sections: {
      ...DEFAULT_SITE_CONFIG.sections,
      ...(config?.sections || {}),
    },
    pages: {
      ...DEFAULT_SITE_CONFIG.pages,
      ...(config?.pages || {}),
    },
  };
  if (typeof window !== 'undefined') {
    window.dispatchEvent(
      new CustomEvent('nexus:site-config', { detail: cache })
    );
  }
  return cache;
}

export async function fetchSiteConfig({ force = false } = {}) {
  if (!force && cache) return cache;
  if (!force && inflight) return inflight;

  inflight = fetch(`${FUNCTIONS_BASE}/site-config`)
    .then(async (res) => {
      const data = await res.json().catch(() => ({}));
      if (!res.ok || !data.config) {
        return { ...DEFAULT_SITE_CONFIG };
      }
      return {
        ...DEFAULT_SITE_CONFIG,
        ...data.config,
        sections: {
          ...DEFAULT_SITE_CONFIG.sections,
          ...(data.config.sections || {}),
        },
        pages: {
          ...DEFAULT_SITE_CONFIG.pages,
          ...(data.config.pages || {}),
        },
      };
    })
    .catch(() => ({ ...DEFAULT_SITE_CONFIG }))
    .then((config) => {
      cache = config;
      inflight = null;
      return config;
    });

  return inflight;
}

const siteConfigService = {
  DEFAULT_SITE_CONFIG,
  fetchSiteConfig,
  clearSiteConfigCache,
  setSiteConfigCache,
};

export default siteConfigService;
